<div class="example-container mat-elevation-z8">
  <div class="example-table-container">
    <div mat-dialog-content class="dialog-body">
      <div class="dialog-header">{{title}}</div>
      <mat-form-field class="dialog-input-element">
          <mat-label>Denominazione Standard Formativo</mat-label>
          <input matInput type="text" class="dialog-input-element-text" [(ngModel)]="corso.descrizione" [disabled]="isDisabled">
      </mat-form-field>
      <mat-form-field class="dialog-input-element">
        <mat-label class="dialog-input-element-label">Normativa di Riferimento</mat-label>
        <input matInput type="text" class="dialog-input-element-text" [(ngModel)]="corso.normativa" [disabled]="isDisabled">
      </mat-form-field>
      <mat-form-field class="dialog-input-element">
        <mat-label class="dialog-input-element-label">Durata complessiva del percorso (ore)</mat-label>
        <input matInput type="number" class="dialog-input-element-text" [(ngModel)]="corso.durata" [disabled]="isDisabled">
      </mat-form-field>
      <mat-form-field class="dialog-input-element">
        <mat-label class="dialog-input-element-label">Numero Annualità</mat-label>
        <input matInput type="number" class="dialog-input-element-text" [(ngModel)]="corso.annualita" [disabled]="isDisabled">
      </mat-form-field>
      <mat-form-field class="dialog-input-element">
        <mat-label class="dialog-input-element-label">Durata di Aula (ore)</mat-label>
        <input matInput type="number" class="dialog-input-element-text" [(ngModel)]="corso.aula" [disabled]="isDisabled">
      </mat-form-field>
      <mat-form-field class="dialog-input-element">
        <mat-label class="dialog-input-element-label">Durata di Esercitazione (ore)</mat-label>
        <input matInput type="number" class="dialog-input-element-text" [(ngModel)]="corso.esercitazione" [disabled]="isDisabled">
      </mat-form-field>
      <mat-form-field class="dialog-input-element">
        <mat-label class="dialog-input-element-label">Durata di Stage</mat-label>
        <input matInput type="number" class="dialog-input-element-text" [(ngModel)]="corso.stage" [disabled]="isDisabled">
      </mat-form-field>
      <mat-form-field class="dialog-input-element">
        <mat-label class="dialog-input-element-label">Percentuale massima di FAD (aula)</mat-label>
        <input matInput type="number" class="dialog-input-element-text" [(ngModel)]="corso.fadPercentuale" [disabled]="isDisabled">
      </mat-form-field>
      <mat-form-field class="dialog-input-element">
        <mat-label class="dialog-input-element-label">Gestione dei crediti formativi</mat-label>
        <input matInput type="number" class="dialog-input-element-text" [(ngModel)]="corso.creditiPercentuale" [disabled]="isDisabled">
      </mat-form-field>
      <mat-form-field class="dialog-input-element">
        <mat-label class="dialog-input-element-label">Percentuale minima di frequenza</mat-label>
        <input matInput type="number" class="dialog-input-element-text" [(ngModel)]="corso.frequenzaMinPerc" [disabled]="isDisabled">
      </mat-form-field>
      <mat-form-field class="dialog-input-element">
        <mat-label class="dialog-input-element-label">Requisiti minimi di accesso al percorso partecipanti</mat-label>
        <input matInput type="text" class="dialog-input-element-text" [(ngModel)]="corso.requisiti" [disabled]="isDisabled">
      </mat-form-field>
      <mat-form-field class="dialog-input-element">
        <mat-label class="dialog-input-element-label">Commissione di Esame</mat-label>
        <input matInput type="text" class="dialog-input-element-text" [(ngModel)]="corso.commissione" [disabled]="isDisabled">
      </mat-form-field>
      <mat-form-field class="dialog-input-element">
        <mat-label class="dialog-input-element-label">Elenco delle Unità Formative</mat-label>
        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"
          class="dialog-input-element-text" [(ngModel)]="corso.unitaFormative" [disabled]="isDisabled"></textarea>
      </mat-form-field>
      <mat-form-field class="dialog-input-element">
        <mat-label class="dialog-input-element-label">Certificazione Rilasciata</mat-label>
        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"
          class="dialog-input-element-text" [(ngModel)]="corso.certificazione" [disabled]="isDisabled"></textarea>
      </mat-form-field>
      <mat-form-field class="dialog-input-element">
        <mat-label class="dialog-input-element-label">Eventuali ulteriori indicazioni</mat-label>
        <input matInput type="text" class="dialog-input-element-text" [(ngModel)]="corso.altreIndicazioni" [disabled]="isDisabled">
      </mat-form-field>
  </div>
</div>
